import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const subscribedPortfolioSelector = ({ subscribedPortfolio }: ReducerState) => subscribedPortfolio;
export const subscribedPortfolioLoadingSelector = createSelector(
  subscribedPortfolioSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
